var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"toc-root"},_vm._l((_vm.toc),function(item){return _c('TocNode',{key:item.id,attrs:{"item":item,"level":1,"is-open":_vm.isOpen(item.id),"toggle":_vm.toggle,"accordion-first-level":_vm.accordionFirstLevel,"is-open-fn":_vm.isOpen}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }